import { useContext } from "react";
import { GlobalStateContext } from "@utils/GlobalContext";
import Accordion from 'react-bootstrap/Accordion';
import { sessionApi, resourceApi } from "@utils/interceptors";

function CambiaRuolo() {
    const { profile, setProfile } = useContext(GlobalStateContext);

    const handleChangeRole = async(item) => {
        try {
            await sessionApi.get(`/session/${item}`);
            const res = await resourceApi.get(`/get_myself`)
                setProfile(res);
            
            window.location.reload();
        } catch (err) {
            console.error(err)
        }
    }

    return profile && Object.keys(profile).length >0 && (
        <Accordion style={{width:'100%'}} >
            <Accordion.Item eventKey="0">
                <Accordion.Header >
                    <i className="icon icon-account-switch"></i>
                    <span className="nhg" style={{lineHeight: '18px'}}>Cambia Ruolo</span>
                </Accordion.Header>
                <Accordion.Body>
                    <div className="d-flex row">
                        {profile.roles.map((item, index) => (
                            <div key={index} className={`col-md-12 role-select`}>
                                
                            <button 
                                style={{width:'100%',padding:'7px', margin:'3px 0',cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'flex-start'}}
                                onClick={() => {profile.role === item ? null : handleChangeRole(item)}}
                                className={`${profile.role === item ? 'current' : ''}`}
                            ><><i style={{marginBottom: 0,marginRight:10}} className={`icon icon-${item} icon-menu`}></i> 
                            <div style={{lineHeight: '18px'}} className={profile.role === item ? 'text-white nhg' : ' nhg'}>{String(item).charAt(0).toUpperCase() + String(item).slice(1)}</div>
                            </>
</button>
                            </div>
                        ))}
                    </div>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
}

export default CambiaRuolo;
